import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemOrderKind extends Cloneable {
    static NONE = new ItemOrderKind(0, "NONE");

    static _values = [
        this.NONE,
        new ItemOrderKind(1, "HARRY_SELLER"),
        new ItemOrderKind(2, "AP_EXG_WOOD_0"),
        new ItemOrderKind(3, "AP_EXG_WOOD_1"),
        new ItemOrderKind(4, "AP_PR_WOOD_0")
        
    ]

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemOrderKind.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof ItemOrderKind) {
            return ItemOrderKind._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemOrderKind.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof ItemOrderKind) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemOrderKind());
        } else if (target instanceof ItemOrderKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemOrderKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});